var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"hiq-header__menu-button mobile",class:{'expanded': _vm.showMenu},attrs:{"aria-label":"Mobilmeny","aria-controls":"mobile_menu","aria-expanded":_vm.showMenu ? 'true' : 'false',"data-ignore-close":""},on:{"click":function($event){return _vm.openMenu()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }